<template>
  <div class="inline-block">
    <el-upload class="inline-block" action="" :http-request="loadImage" :show-file-list="false" accept=".png,.jpg,.gif">
      <el-button type="default">上传文件</el-button>
    </el-upload>
    <el-dialog title="图片裁剪" v-if="option.show" :visible.sync="option.show" width="600px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <div class="flex-center">
        <div style="width: 350px;">
          <vue-cropper ref="cropper" :img="option.img" :output-size="option.size" :output-type="option.outputType" :info="true" :full="option.full"
                       :can-move="option.canMove" :can-move-box="option.canMoveBox" :fixed-box="option.fixedBox" :original="option.original"
                       :auto-crop="option.autoCrop" :auto-crop-width="option.autoCropWidth" :auto-crop-height="option.autoCropHeight"
                       :center-box="option.centerBox" :high="option.high" :fixed-number="option.fixedNumber" :fixed="option.fixed"
                       mode="cover" @real-time="realTime" :max-img-size="option.max" style="height: 350px;"></vue-cropper>
          <div class="text-center" style="letter-spacing: 20px;margin-top: 20px;">
            <i @click="rotateLeft" class="icon icon_back pointer" style="font-size: 30px;"></i>
            <i @click="rotateRight" class="icon icon_forward pointer" style="font-size: 30px;"></i>
          </div>
        </div>
        <div class="text-right" style="width: 250px;">
          <el-upload class="inline-block" style="margin-left: 10px;" action="" :http-request="loadImage" :show-file-list="false" accept=".png,.jpg,.gif">
            <el-button type="default" style="margin-top: 20px;">重新上传</el-button>
          </el-upload>
          <div style="margin-top: 20px;min-height: 200px;">
            <div class="inline-block" :style="{'width': option.previews.w + 'px', 'height': option.previews.h + 'px',  'overflow': 'hidden', 'margin': '5px'}">
              <div :style="option.previews.div">
                <img :src="option.previews.url" :style="option.previews.img">
              </div>
            </div>
          </div>
          <el-button @click="cancel" type="default" style="margin-top: 20px;">取消</el-button>
          <el-button @click="save" type="primary" style="margin-top: 20px;">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { VueCropper } from 'vue-cropper'

export default {
  name: 'cropper',
  components: { VueCropper },
  props: [],
  data () {
    return {
      option: {
        show: false,
        img: '',
        size: 1,
        full: true,
        outputType: 'png',
        canMove: true,
        fixedBox: false,
        original: false,
        canMoveBox: true,
        autoCrop: true,
        autoCropWidth: 200,
        centerBox: false,
        high: true,
        fixed: true,
        fixedNumber: [1, 1],
        max: 99999,
        previews: {}
      }
    }
  },
  async created () {
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    loadImage (event) {
      try {
        if (event.file.size > 1024 * 1024 * 2) {
          throw new Error('仅支持JPG、PNG、GIF格式图片文件，且文件大小小于2MB')
        }
        let reader = new window.FileReader()
        reader.readAsDataURL(event.file)
        reader.onload = (e) => {
          let url = e.target.result
          this.option.show = true
          this.option.img = url
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    realTime (data) {
      this.option.previews = data
    },
    rotateLeft () {
      this.$refs.cropper.rotateLeft()
    },
    rotateRight () {
      this.$refs.cropper.rotateRight()
    },
    cancel () {
      this.option.show = false
      this.$emit('close')
    },
    save () {
      this.$refs.cropper.getCropData((data) => {
        console.log(data)
      })
    }
  }
}
</script>
